import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ActionTypes } from '../api/playbooks/actions/actionTypes.enum';
import { toKebab, humanize } from 'src/app/common/stringUtils';

const baseOptions: ISelectOption[] = [
  {
    id: 'create',
    value: 'Create',
    displayName: 'Create',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'edit',
    value: 'Edit',
    displayName: 'Edit',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'delete',
    value: 'Delete',
    displayName: 'Delete',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'login',
    value: 'Login',
    displayName: 'Login',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'exempt',
    value: 'Exempt',
    displayName: 'Exempt',
    filterType: FilterTypesEnum.Exempted,
    categoryName: FilterTypesEnum.Exempted,
  },
  {
    id: 'set-agent-authentication',
    value: 'Set agent authentication',
    displayName: 'Set agent authentication',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'set-agent-web-browsing',
    value: 'Set agent web browsing',
    displayName: 'Set agent web browsing',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'grant-access',
    value: 'Grant access',
    displayName: 'Grant access',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: 'remove-access',
    value: 'Remove access',
    displayName: 'Remove access',
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
];

const existingIds = new Set(baseOptions.map((o) => o.id));

const generatedFromActionTypes: ISelectOption[] = Object.values(ActionTypes)
  .map((a) => {
    const id = toKebab(a);
    return {
      id,
      value: humanize(a),
      displayName: humanize(a),
      filterType: FilterTypesEnum.ExecutionStatus,
      categoryName: FilterTypesEnum.ExecutionStatus,
    } as ISelectOption;
  })
  .filter((opt) => !existingIds.has(opt.id));

const sortByCategoryThenName = (a: ISelectOption, b: ISelectOption) => {
  const catCmp = (a.categoryName ?? '').localeCompare(b.categoryName ?? '');
  if (catCmp) return catCmp;

  return (a.displayName ?? a.value ?? '').localeCompare(b.displayName ?? b.value ?? '');
};

export const AuditLogActionOptions: ISelectOption[] = [...baseOptions, ...generatedFromActionTypes].sort(
  sortByCategoryThenName
);
